import * as factory from '../../../iawp/src/js/factory'
import './jquery.serialscrolling'
import './filterFaqs'
import {gallerySlider} from './gallery-slider'
import openMobileSubmenu from '../../../iawp/src/js/modules/openMobileSubmenu'

new factory.IAInit()
openMobileSubmenu()

document.querySelectorAll('.ia-block-dropdown').forEach((dropdown)=>{
    new factory.IADropdown(
        dropdown.querySelector('.ia-block-dropdown-toggle'), 
        dropdown.querySelector('.ia-block-dropdown-content') 
    )
})

if (!!document.querySelector('#newsletterForm')) {
    document.querySelectorAll('#newsletterForm').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '#newsletterForm'
        }).formInside(true)
        form.querySelector('[type="submit"]').addEventListener('click', e => {
            if(form.querySelector('input[name="email"]').value == '' || form.querySelector('input[name="email"]').classList.contains('error')){
                form.querySelector('input[name="email"]').focus()
            }
        })
    })
}
if (!!document.querySelector('.js-ia-blocks-form')) {
    document.querySelectorAll('.js-ia-blocks-form').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '.contactForm'
        }).formInside(true)
    })
}
if (!!document.querySelector('.captcha-option')) {
    document.querySelectorAll('.captcha-option input').forEach(captchaOption => {
        captchaOption.addEventListener('click', (evt) => {
            let that = evt.currentTarget
            let target = document.getElementById(evt.currentTarget.getAttribute('data-target'))

            if (that.checked) {
                target.value = that.value
            } else {
                target.value = ''
            }
            target.dispatchEvent(new Event('change'))
        })
    })
}
if (!!document.querySelector('#membership')) {
    document.querySelector('#membership').addEventListener('change', (e) => {
        //console.log(e)
        let option = e.currentTarget.value
        let phoneInput = document.querySelector('#phone')
        let phoneLabel = phoneInput.previousElementSibling
        if (option === 'not_account') {
            phoneInput.removeAttribute('required')
            phoneLabel.classList.remove('is-required')
        }else{
            phoneInput.setAttribute('required', true)
            phoneLabel.classList.add('is-required')
        }
        //console.log({option,phoneInput,phoneLabel});

    })
}

if(!!document.querySelectorAll('.ia-block-latest-post .load-more')){
    document.querySelectorAll('.ia-block-latest-post .load-more').forEach(newsButton => {
        newsButton.addEventListener('click', (e)=>{
            new factory.IALoadMore().addLoader(newsButton)
        })
    })
}
if(!!document.querySelectorAll('.ia-block-list-faq')){
    document.querySelectorAll('.ia-block-list-faq__item').forEach((dropdown)=>{
        new factory.IADropdown(
            dropdown.querySelector('.ia-block-list-faq__item__dropdown'), 
            dropdown.querySelector('.dropdown-content') 
        )
    })
}
var ready = (callback) => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}
ready(() => {

    factory.$('.js-serialscrolling').removeClass('current-menu-item').removeClass('current_page_item');
    factory.$('.js-serialscrolling a').serialscrolling({'offsetTop':-50-(document.querySelector('.section-header').offsetHeight)});
    factory.$('.js-serialscrolling .wp-block-button__link').serialscrolling({'offsetTop':-50-(document.querySelector('.section-header').offsetHeight)});

    gallerySlider()
    swiperInit()
})


function swiperInit() {
    if (!!document.querySelector('.swiper-container')) {
        document.querySelectorAll('.swiper-container:not(.is-fullwidth').forEach((el) => {
            if(el.classList.contains('ia-block-process__container')){
                const swiperInstance = new factory.IASwiper(el, {
                    // Overriding rules
                    autoplay: false,
                    itemPerSlide: 3.2,
                    spaceBetween: 32,
                    // Custom rules
                    scrollbar: {
                        el: el.querySelector('.swiper-scrollbar'),
                        draggable: true,
                    },
                    breakpoints : {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 20
                        },
                        580: {
                            slidesPerView: 2,
                            spaceBetween: 20
                        },
                        820: {
                            slidesPerView: 3.2,
                            spaceBetween: 20
                        },
                        1150: {
                            slidesPerView: 3.2,
                            spaceBetween: 32
                        }
                    } 
                })
            }
        })
    }
}